import { render, staticRenderFns } from "./EditKosiwonModal.vue?vue&type=template&id=db42022c&scoped=true&"
import script from "./EditKosiwonModal.vue?vue&type=script&lang=js&"
export * from "./EditKosiwonModal.vue?vue&type=script&lang=js&"
import style0 from "./EditKosiwonModal.vue?vue&type=style&index=0&id=db42022c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db42022c",
  null
  
)

export default component.exports